import styled from "@emotion/styled";

export const StyledSpan = styled.div`
  width: 22px;
  height: 16px;
  margin-right: ${({ theme }) => theme.space[3]}px;
  border-radius: 4px;

  background-image: url("/assets/images/flags-sprite.png");
`;
